<template>
  <div class="formulario">
    <div>
      <h1 v-if="tipoTransporteNormalizado === 'indefinido'">Solicitação de Transporte</h1>
      <h1 v-else-if="tipoTransporteNormalizado === 'executivo'">Solicitação de Transporte Executivo</h1>
      <h1 v-else-if="tipoTransporteNormalizado === 'carga'">Solicitação de Transporte de Carga</h1>
      <h1 v-else-if="tipoTransporteNormalizado === 'grupo'">Solicitação de Transporte de Grupos</h1>
      <br />
      <button @click="goHome()">Voltar</button>
      <br /> <br />
    </div>

    <!--Dados do Responsável pela Viagem -->
    <div id="dados-responsavel-viagem">
      <h2>Dados do Responsável pela Viagem</h2>

      <br />

      <UnidadeSelect @unidade-selecionada="receberEmitUnidade" />
      <CentroOrcamentarioSelect @co-selecionado="receberEmitCO" :siglaUnidade="this.solicitacao.unidade.sigla" />
      <ContaLocalSelect @contas-locais-change="updateContasLocaisStatus" @cl-selecionado="receberEmitCL"
        :centroOrcamentario="this.solicitacao.unidade.centroOrcamentario"
        :siglaUnidade="this.solicitacao.unidade.sigla" />

      <label for="responsavel" class="required">Responsável:</label>
      <input v-model="solicitacao.responsavelPelaSolicitacao" type="text" id="responsavel" readonly />


      <br />
      <label for="ramal" class="required">Ramal:</label>
      <input v-model="solicitacao.ramal" type="text" id="ramal" />

      <br />
      <label for="telefoneForaExpediente" class="required">Telef. Fora Expediente:</label>
      <input type="text" id="telefoneForaExpediente" v-model="solicitacao.telefoneForaExpediente" />

      <!-- div para receber as mensagens de erro-->
      <div v-if="errosDadosResponsavel.length" class="error-messages">
        <ul>
          <li v-for="(erro, index) in errosDadosResponsavel" :key="index">{{ erro }}</li>
        </ul>
      </div>
    </div>

    <!--Dados Gerais da Viagem -->
    <br /><br />
    <div id="dados-gerais-viagem">
      <h2>Dados Gerais da Viagem</h2>

      <br /><br />
      <div id="tipoTransporte" v-if="solicitacao.tipoTransporte === 'Indefinido'">
        <label for="tipoTransporteSelect" class="required">Tipo de Transporte:</label>
        <select id="tipoTransporteSelect" v-model="solicitacao.tipoTransporte">
          <option value="Executivo">Transporte Executivo</option>
          <option value="Carga">Transporte de Carga</option>
        </select>
      </div>

      <TipoViagemSelect @tipo-viagem-selecionado="receberEmitTipoViagem" v-if="this.tipoTransporteNormalizado === 'grupo'"/>
      <TipoVeiculoSelect @tipo-veiculo-selecionado="receberEmitTipoVeiculo" @capacidade-passageiro-selecionado="receberEmitCapacidadePassageiro" :tipoViagem="this.solicitacao.tipoViagem" v-if="this.tipoTransporteNormalizado === 'grupo'" />

      <div>
        <label for="date" class="required">Data da Partida:</label>
        <input type="date" class="estilo10" id="dataDaPartida" :min="this.dataMinima" v-model="solicitacao.dataDaPartida">

        <div class="instrucoes">
          Você pode inserir o agendamento com {{ this.getTotalDiasUteisParaSolicitacao() }} dias úteis de antecedência à
          viagem.
          <span v-if="this.tipoTransporteNormalizado === 'executivo'">
            Caso necessite de veículo para situações emergenciais, consulte a opção de Transporte por táxi.
          </span>
        </div>
      </div>

      <div v-if="tipoTransporteNormalizado === 'carga' || tipoTransporteNormalizado === 'grupo'">
        <label for="horarioDaPartida" class="required">Horário Partida:</label>
        <input type="time" id="horarioDaPartida" v-model="solicitacao.horarioDaPartida" class="estilo10" />
      </div>

      <div id="especificacaoCarga" class="campo-textarea" v-if="tipoTransporteNormalizado === 'carga'">
        <br />
        <label for="especificacaoCargaText" class="required">Especificação da carga transportada:</label>
        <textarea v-model="solicitacao.especificacaoDaCarga" id="especificacaoCargaText" rows="4" cols="15"
          class="estilo30"></textarea>
        <div class="instrucoes">
          O veículo é tipo pick-up fechada, suportando até 700kg. É permitido somente cargas secas, não vivas e não
          refrigeradas.
        </div>
      </div>

      <div id="passageiroAcompanhante" v-if="tipoTransporteNormalizado === 'carga'">
        <label for="passageiroAcompanhanteSelect" class="required">Necessidade passageiro acompanhante:</label>
        <select id="passageiroAcompanhanteSelect" v-model="solicitacao.necessidadePassageiroAcompanhante">
          <option value="Não">Não</option>
          <option value="Sim">Sim</option>
        </select>
        <div class="instrucoes" v-if="this.solicitacao.necessidadePassageiroAcompanhante === 'Sim'">
          Importante - Após a realização da viagem de carga, o retorno do passageiro
          acompanhante deverá ser na Unicamp.
        </div>
      </div>


      <br />
      <div id="aeroporto">
        <div id="ehAeroporto">
          <label for="airportoselect" class="required">É aeroporto?:</label>
          <select id="airportoselect" v-model="solicitacao.aeroporto.selecionado">
            <option value="Não">Não</option>
            <option value="Origem">Origem</option>
            <option value="Destino">Destino</option>
          </select>
        </div>
      </div>
      <DadosAeroporto @aeroporto-informado="receberEmitAeroporto"
        @endereco-aeroporto-informado="receberEmitEnderecoAeroporto" :isAeroporto="solicitacao.aeroporto.selecionado"
        :dataMinima="this.dataMinima"
        v-if="solicitacao.aeroporto.selecionado !== 'Não' && solicitacao.aeroporto.selecionado !== null" />

      <div v-if="tipoTransporteNormalizado === 'grupo'">
        <label for="qtdePassageiros" class="required">Quantidade de Passageiros:</label>
        <input type="number" id="qtdePassageiros" v-model="solicitacao.qtdePassageiros" :min="2" class="estilo10" />
      </div>


      <br />
      <!-- div para receber as mensagens de erro-->
      <div v-if="errosDadosGerais.length" class="error-messages">
        <ul>
          <li v-for="(erro, index) in errosDadosGerais" :key="index">{{ erro }}</li>
        </ul>
      </div>
    </div>

    <!-- Passageiros -->
    <br /><br />
    <div id="passageiros"
      v-if="tipoTransporteNormalizado === 'grupo' || tipoTransporteNormalizado === 'executivo' || (tipoTransporteNormalizado === 'carga' && this.solicitacao.necessidadePassageiroAcompanhante === 'Sim')">
      <div id="cad-passageiros">
        <h2
          v-if="tipoTransporteNormalizado === 'executivo' || (tipoTransporteNormalizado === 'carga' && this.solicitacao.necessidadePassageiroAcompanhante === 'Sim')">
          Passageiros
        </h2>
        <h2 v-if="tipoTransporteNormalizado === 'grupo'">
          Responsável
        </h2>
        <Passageiro @passageiro-informado="salvarPassageiro" :passageiro="this.passageiroEditando"
          :endereco="this.solicitacao.aeroporto.selecionado === 'Origem' ? this.enderecoAeroporto : null"
          :exibirHorarioDaPartida="this.tipoTransporteNormalizado === 'executivo'"
          :enderecoApenasLeitura="this.solicitacao.aeroporto.selecionado === 'Origem'" ref="passageiroComponent" />

        <br />
        <!-- div para receber as mensagens de erro dos passageiros-->
        <div v-if="errosPassageiros.length" class="error-messages">
          <ul>
            <li v-for="(erro, index) in errosPassageiros" :key="index">{{ erro }}</li>
          </ul>
        </div>
      </div>

      <div id="cad-lista-passageiros">
        <div>
          <h2
            v-if="tipoTransporteNormalizado === 'executivo' || (tipoTransporteNormalizado === 'carga' && this.solicitacao.necessidadePassageiroAcompanhante === 'Sim')">
            Passageiros registrados
          </h2>
          <h2 v-if="tipoTransporteNormalizado === 'grupo'">
            Responsável registrado
          </h2>

          <div class="instrucoes">
            <span v-if="tipoTransporteNormalizado === 'grupo'">
              Necessário 2 responsáveis por viagem.
            </span>
            <span v-if="tipoTransporteNormalizado === 'executivo'">
              Limite de 4 passageiros por veículo para transporte executivo.
            </span>
            <span v-if="tipoTransporteNormalizado === 'carga'">
              Limite de 1 passageiro para transporte de carga.
            </span>
          </div>
          <br />
          <div class="instrucoes" v-if="tipoTransporteNormalizado === 'grupo'">
              A lista de passageiros deve ser encaminhada em até 03 dias úteis de antecedência ao dia da viagem. <br />Faça o download da lista de passageiros. 
              <a :href="listaPassageirosUrl" download="lista_passageiros.doc">Baixar agora</a>
          </div>

        </div>
        <br />
        <ul>
          <li v-for="(p, index) in solicitacao.passageiros" :key="index" class="passageiro-item">
            <div class="passageiro-detalhes">
              <p>Horário Partida: {{ p.horarioDaPartida }}</p>
              <p>Nome: {{ p.nome }}</p>
              <p>Telefone: {{ p.telefone }}</p>
              <p>Email: {{ p.email }}</p>
              <p>Vinculo: {{ p.vinculo }}</p>
              <p>RA/RG/RE/Matrícula: {{ p.raRgReMatricula }}</p>
              <p>Local Apresentação: {{ p.localApresentacao }}</p>
              <p v-if="p.endereco != null">Endereço: {{ p.endereco.endereco }}, {{ p.endereco.numero }} - {{
                p.endereco.bairro }} - {{ p.endereco.cidade }}/{{ p.endereco.estado }}
              </p>
              <p v-if="p.endereco.numero != null">Complemento: {{ p.endereco.complemento }}</p>
              <p v-if="p.endereco.pontoReferencia != null">Ponto Referência: {{ p.endereco.pontoReferencia }} </p>
            </div>
            <div class="button-group">
              <button @click="editarPassageiro(index)" :disabled="editandoPassageiroIndex === index"
                class="editar-button">Editar</button>
              <button @click="confirmarExcluirPassageiro(index)" :disabled="editandoPassageiroIndex === index"
                class="apagar-button">Excluir</button>
            </div>
          </li>
        </ul>
      </div>
    </div>


    <div id="cad-origem-quando-carga"
      v-if="tipoTransporteNormalizado === 'carga'">
      <h2>Endereço de Origem da Carga</h2>
      <br />
      <label for="local-apresentacao-carga" class="required">Local de apresentação:</label>
      <input v-model="this.solicitacao.localApresentacaoCarga" type="text" id="local-apresentacao-carga" placeholder=""
        class="estilo60" />

      <Endereco @endereco-informado="receberEmitEnderecoCarga" v-model:endereco="this.solicitacao.enderecoOrigemCarga"
        ref="enderecoComponent" />

      <!-- div para receber as mensagens de erro dos destinos intermediários-->
      <div v-if="errosOrigemQuandoCarga.length" class="error-messages">
        <ul>
          <li v-for="(erro, index) in errosOrigemQuandoCarga" :key="index">{{ erro }}</li>
        </ul>
      </div>
    </div>

    <br />
    <div id="cad-destino-questao" style="width: 100%;">
      <label for="destinoIntermediarioSel">Tem destino intermediário?:</label>
      <select id="destinoIntermediarioSel" v-model="this.solicitacao.temDestinoIntermediario" class="estilo20">
        <option value="Não">Não</option>
        <option value="Sim">Sim</option>
      </select>
      <br />
      <!-- div para receber as mensagens de erro dos destinos intermediários-->
      <div v-if="errosDestinoIntermediarioQuestao.length" class="error-messages">
        <ul>
          <li v-for="(erro, index) in errosDestinoIntermediarioQuestao" :key="index">{{ erro }}</li>
        </ul>
      </div>
    </div>

    <!-- Destinos Intermediários -->
    <span v-if="this.solicitacao.temDestinoIntermediario === 'Sim'">
      <br /><br />
    </span>
    <div id="destinos-intermediarios" v-if="this.solicitacao.temDestinoIntermediario === 'Sim'">
      <div id="cad-destinos">
        <h2>Destinos Intermediários</h2>

        <DestinoIntermediario @destIntermediario-informado="salvarDestIntermediario"
          :destIntermediario="this.destIntermediarioEditando" :dataMinima="this.dataMinima" :exibirLocalHospedagem="tipoTransporteNormalizado === 'grupo'" :obrigatorioLocalHospedagem="isObrigatorioLocalHospedagem()"
          ref="destinoIntermediarioComponent" />

        <br />
        <!-- div para receber as mensagens de erro dos destinos intermediários-->
        <div v-if="errosDestinos.length" class="error-messages">
          <ul>
            <li v-for="(erro, index) in errosDestinos" :key="index">{{ erro }}</li>
          </ul>
        </div>
      </div>

      <div id="cad-lista-destinos">
        <h2>Destinos registrados</h2>
        <br />
        <ul>
          <li v-for="(d, index) in solicitacao.destinosIntermediarios" :key="index" class="destino-item">
            <div class="destino-intermediario-detalhes">
              <h3>DESTINO {{ index + 1 }} </h3>
              <p>CEP: {{ d.endereco.cep }}</p>
              <p>Endereço: {{ d.endereco.endereco }}</p>
              <p>Número: {{ d.endereco.numero }}</p>
              <p>Complemento: {{ d.endereco.complemento }}</p>
              <p>Bairro: {{ d.endereco.bairro }}</p>
              <p>Cidade: {{ d.endereco.cidade }} - Estado {{ d.endereco.estado }}</p>
              <p>Ponto Referência: {{ d.endereco.pontoReferencia }}</p>
              <p>Previsão Chegada: {{ this.formatarDataBR(d.dataPrevisaoChegada) }} {{ d.horaPrevisaoChegada }}</p>
              <p>Previsão Partida: {{ this.formatarDataBR(d.dataPrevisaoPartida) }} {{ d.horaPrevisaoPartida }}</p>
              <p>Local de Hospedagem: {{ d.localHospedagem }}</p>

            </div>
            <div class="button-group">
              <button @click="editarDestinoIntermediario(index)" :disabled="editandoDestIntermediarioIndex === index"
                class="editar-button">Editar</button>
              <button @click="confirmarExcluirDestinoIntermediario(index)"
                :disabled="editandoDestIntermediarioIndex === index" class="apagar-button">Excluir</button>
            </div>

            <br /><br />
            <!-- div para receber as mensagens de erro dos destinos intermediarios (DATA)-->
            <div v-if="errosDestinosData.length" class="error-messages">
              <ul>
                <li v-for="(erro, index) in errosDestinosData" :key="index">{{ erro }}</li>
              </ul>
            </div>
          </li>
        </ul>
      </div>

    </div>

    <br /><br />
    <div id="destino-final-info-adicionais">
      <div id="cad-destino-final">
        <h2>Destino Final</h2>

        <br />
        <label for="dataRetorno" class="required">Data Retorno:</label>
        <input type="date" id="dataRetorno" :min="this.dataMinima" v-model="solicitacao.destinoFinal.dataRetorno" />

        <br />
        <label for="horarioRetorno" class="required">Horário Retorno:</label>
        <input type="time" id="horarioRetorno" v-model="solicitacao.destinoFinal.horarioRetorno" />


        <br />
        <label for="local-destino-final" class="required">Nome Local/Destino:</label>
        <input v-model="solicitacao.destinoFinal.localDestinoFinal" type="text" id="local-destino-final" placeholder=""
          class="estilo60" />

        <br />
        <Endereco @endereco-informado="receberEmitEndereco"
          :endereco="this.solicitacao.aeroporto.selecionado === 'Destino' ? this.enderecoAeroporto : null"
          :apenasLeitura="this.solicitacao.aeroporto.selecionado === 'Destino'" />

        <div v-if="tipoTransporteNormalizado !== 'grupo' && this.solicitacao.necessidadePassageiroAcompanhante !== 'Não'">
          <label for="motoristaAguardar" class="required">Motorista aguardar para retorno:</label>
          <select id="motoristaAguardar" v-model="solicitacao.destinoFinal.motoristaAguardar">
            <option value=""></option>
            <option value="Não">Não</option>
            <option value="Sim">Sim</option>
          </select>

          <div class="instrucoes" style=" max-width: 200px;">
            Selecione esta opção caso necessite que o motorista esteja à disposição durante todo o período da viagem.
          </div>
        </div>

        <div v-if="tipoTransporteNormalizado === 'grupo'">
          <label for="localHospedagem" :class="{ required: isObrigatorioLocalHospedagem() }">Local de Hospedagem:</label>
          <input v-model="solicitacao.destinoFinal.localHospedagem" type="text" id="localHospedagem" placeholder=""
          class="estilo60" />
        </div>
        <br /><br />

        <!-- div para receber as mensagens de erro dos destinos final-->
        <div v-if="errosDestinoFinal.length" class="error-messages">
          <ul>
            <li v-for="(erro, index) in errosDestinoFinal" :key="index">{{ erro }}</li>
          </ul>
        </div>
      </div>

      <div id="cad-info-adicionais">
        <h2>Informações Adicionais</h2>

        <br />
        <Finalidade @finalidade-selecionada="receberEmitFinalidade" />


        <div class="campo-textarea">
          <label for="detalhesFinalidade" class="required">Especificar:</label>
          <textarea v-model="solicitacao.infoAdicionais.finalidade.detalhes" id="detalhesFinalidade" rows="4" cols="15"
            class="estilo60"></textarea>
        </div>

        <div class="campo-textarea">
          <label for="infoAdicionaisObservacoes">Observações:</label>
          <textarea v-model="solicitacao.infoAdicionais.observacoes" id="infoAdicionaisObservacoes" rows="4" cols="15"
            class="estilo60"></textarea>
        </div>

        <br />

        <!-- div para receber as mensagens de erro dos destinos final-->
        <div v-if="errosInformacoesAdicionais.length" class="error-messages">
          <ul>
            <li v-for="(erro, index) in errosInformacoesAdicionais" :key="index">{{ erro }}</li>
          </ul>
        </div>
      </div>


    </div>
    <div>
      <br />
      <button @click="enviarSolicitacao()" style="display: block; margin: 0 auto;">Enviar solicitação</button>
    </div>
  </div>
</template>

<script>

import CentroOrcamentarioSelect from '@/components/CentroOrcamentario.vue';
import UnidadeSelect from '@/components/Unidade.vue';
import ContaLocalSelect from '@/components/ContaLocal.vue';
import TipoViagemSelect from '@/components/TipoViagem.vue';
import TipoVeiculoSelect from '@/components/TipoVeiculo.vue';
import Passageiro from '@/components/Passageiro.vue';
import DestinoIntermediario from '@/components/DestinoIntermediario.vue';
import DadosAeroporto from '@/components/DadosAeroporto.vue';
import Endereco from '@/components/Endereco.vue';
import Finalidade from '@/components/Finalidade.vue';
import * as utils from '@/utils/utils.js';

// necessário importar separadamente para poder usar em um loop v-for
import { formatarDataBR } from '@/utils/utils.js';

export default {
  props: ['updateSistema'],
  name: "TransporteEventualPage",

  methods: {
    goHome() {
      this.$router.push({ name: 'servicos' });
    },

    receberEmitCO(co) {
      this.solicitacao.centroOrcamentario = co;
      this.solicitacao.unidade.centroOrcamentario = co;

      // reset na conta local
      this.solicitacao.contaLocal = null;
      this.solicitacao.unidade.contaLocal = null;
    },

    receberEmitCL(cl) {
      this.solicitacao.contaLocal = cl;
      this.solicitacao.unidade.contaLocal = cl;
    },

    receberEmitTipoVeiculo(t) {
      this.solicitacao.tipoVeiculo = t;
    },

    receberEmitUnidade(u) {
      this.solicitacao.unidade = u;
      //console.log("Recebeu unidade -> " + this.solicitacao.unidade.sigla)

      this.solicitacao.unidade.centroOrcamentario = null;
      //this.solicitacao.unidade.contaLocal = null;
    },

    receberEmitTipoViagem(t) {
      this.solicitacao.tipoViagem = t;
      this.solicitacao.tipoVeiculo = null;
    },

    receberEmitCapacidadePassageiro(t) {
      this.solicitacao.capacidadePassageiros = t;
    //  this.solicitacao.tipoVeiculo = null;
    },

    receberEmitEndereco(e) {
      this.solicitacao.destinoFinal.enderecoDestinoFinal = e;
    },

    receberEmitEnderecoCarga(e) {
      this.solicitacao.enderecoOrigemCarga = e;
    },


    receberEmitFinalidade(f) {
      this.solicitacao.infoAdicionais.finalidade.tipo = f;
    },

    enviarSolicitacao() {
      console.log(JSON.stringify(this.solicitacao, null, 2));

      var validarDadosGerais = this.validarDadosGerais();
      var validarDadosResponsavel = this.validarDadosResponsavel();
      var validarDestinoIntermediarioQuestao = this.validarDestinoIntermediarioQuestao();
      var validarDatasDestinosIntermediarios = this.validarDatasDestinosIntermediarios();
      var validarDestinoFinal = this.validarDestinoFinal();
      var validarInformacoesAdicionais = this.validarInfoAdicionais();
      var validarOrigemQuandoCarga = this.validarOrigemQuandoCarga();
      var validarQtdePassageiros = true;

      if (this.solicitacao.tipoTransporte === 'grupo'){
        validarQtdePassageiros = this.validarQtdeResponsavelGrupo();
      } else if (this.solicitacao.tipoTransporte === 'executivo'){
        validarQtdePassageiros = this.validarQtdePassageirosExecutivo();
      }

      if (true && validarDadosGerais && validarDadosResponsavel && validarDestinoIntermediarioQuestao && validarDestinoFinal && validarInformacoesAdicionais && validarDatasDestinosIntermediarios && validarOrigemQuandoCarga && validarQtdePassageiros) {

        this.$axios.post('/cadastro', this.solicitacao)
          .then((response) => {
            let msg = "Você receberá um e-mail de confirmação das informações registradas e posteriormente, o número de solicitação gerada via Agenda de Transportes. <br /><br />Alterações de itinerário poderão ser realizadas em até 3 dias úteis. Encaminhar pedido para agenda.transporte@unicamp.br";
            
            if (this.solicitacao.tipoTransporte === 'grupo'){
              msg =  "Seu formulário foi recebido. Aguarde a confirmação da viagem e o número gerado via Agenda de Transportes. <br /><br />Alterações de itinerário podem ser realizadas em até 15 dias úteis. Encaminhar pedido para agenda.transporte@unicamp.br. " +
                     "<br /><br />Os cancelamentos devem ser comunicados em até 02 dias úteis de antecedência ao dia da viagem. A Lista de Passageiros deve ser encaminhada em até 03 dias úteis de antecedência ao dia da viagem.";
            }

            console.log("ID: " + response.data.id)

            this.$swal.fire({
              title: 'Seu formulário foi enviado',
              html: msg,
              icon: 'success',
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: true,
              focusConfirm: true
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push("/");
              }
            })
          })
          .catch((error) => {
            console.log(error);
            this.$swal.fire({
              title: 'Erro ocorrido',
              html: "Ocorreu um erro durante o cadastro!",
              icon: 'error',
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: true,
              focusConfirm: true
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push("/");
              }
            })
          })
      } else {
        this.$swal.fire({ title: 'Oops', html: "Seu formulário está com algum problema de preenchimento. Por favor, verifique todos os campos.", icon: 'error' });
      }
    },

    salvarPassageiro(passageiro) {
      const novoPassageiro = {
        ...passageiro
      };

      if (this.validarPassageiro(novoPassageiro)) {

        if (this.isEditandoPassageiro && this.editandoPassageiroIndex !== -1) {
          // Atualizar o passageiro existente
          this.solicitacao.passageiros.splice(this.editandoPassageiroIndex, 1, novoPassageiro);
          this.isEditandoPassageiro = false;
          this.editandoPassageiroIndex = -1;
        } else {
          // Adicionar um novo passageiro
          if (this.solicitacao.passageiros.length < this.getNumMaxPassageiros()) {
            this.solicitacao.passageiros.push(novoPassageiro);
          } else {
            this.$swal.fire({ title: 'Número máximo de passageiros atingida', html: "Para o tipo de transporte escolhido o número máximo de passageiros/responsáveis é " + this.getNumMaxPassageiros(), icon: 'error' });
          }
        }

        this.passageiroEditando = {};

        // necessário para manter os dados do endereco para novo passageiro
        if (this.solicitacao.aeroporto.selecionado === 'Origem' &&
          this.solicitacao.aeroporto.detalhes.nomeAeroporto !== '') {
          this.passageiroEditando.endereco = this.enderecoAeroporto;
        }

      }

    },

    getNumMaxPassageiros() {

      if (this.tipoTransporteNormalizado === 'carga'){
        return 1;
      } else if (this.tipoTransporteNormalizado === 'grupo') {
        return 2;
      } else if (this.tipoTransporteNormalizado === 'executivo') {
        return 4;
      }

    },

    // função para validar o passageiro antes de inserir no array
    validarPassageiro(p) {

      this.errosPassageiros = [];

      if (this.solicitacao.passageiros !== null && this.solicitacao.passageiros.length >= 4) {
        this.errosPassageiros.push('Não é permitido mais que 4 passageiros em uma viagem.');
      }

      if (!p.nome) {
        this.errosPassageiros.push('Campo "Nome" é obrigatório.');
      }
      if (this.tipoTransporteNormalizado === 'executivo') {
        if (!p.horarioDaPartida) {
          this.errosPassageiros.push('Campo "Horário da Partida" é obrigatório.');
        }
      }
      if (!p.telefone) {
        this.errosPassageiros.push('Campo "Telefone" é obrigatório.');
      }
      if (!p.vinculo) {
        this.errosPassageiros.push('Campo "Vínculo" é obrigatório.');
      }
      if (!p.raRgReMatricula) {
        this.errosPassageiros.push('Campo "RA/RG/RG/Matrícula" é obrigatório.');
      }
      if (!p.email) {
        this.errosPassageiros.push('Campo "E-mail" é obrigatório.');
      } else if (!this.validarEmail(p.email)) {
        this.errosPassageiros.push('Campo "E-mail" não está válido.');
      }
      if (!p.localApresentacao) {
        this.errosPassageiros.push('Campo "Local de apresentação" é obrigatório.');
      }

      if (!p.endereco) {
        this.errosPassageiros.push('Nenhum campo do "Endereço" foi preenchido.');
      } else {
        if (!p.endereco.cep) {
          this.errosPassageiros.push('Campo "CEP" é obrigatório.');
        }
        if (!p.endereco.endereco) {
          this.errosPassageiros.push('Campo "Endereço" é obrigatório.');
        }
        if (!p.endereco.numero && !this.solicitacao.aeroporto.selecionado) {
          this.errosPassageiros.push('Campo "Número" é obrigatório.');
        }
        if (!p.endereco.bairro) {
          this.errosPassageiros.push('Campo "Bairro" é obrigatório.');
        }
        if (!p.endereco.cidade) {
          this.errosPassageiros.push('Campo "Cidade" é obrigatório.');
        }
        if (!p.endereco.estado) {
          this.errosPassageiros.push('Campo "Estado" é obrigatório.');
        }
      }

      return this.errosPassageiros.length === 0;

    },

    // valida na hora de submeter o formulario
    validarDatasDestinosIntermediarios() {
      this.errosDestinosData = [];
      let estaOK = true;

      let dataHoraPartida = this.solicitacao.dataDaPartida;

      // se for carga, adicionar a hora da partida a data da partida
      if (this.tipoTransporteNormalizado === 'carga') {
        dataHoraPartida += " " + this.solicitacao.horarioDaPartida;
      } else if (this.tipoTransporteNormalizado === 'executivo') {
        let menorHorarioPassageiro = this.getMaiorHorarioPassageiro();
        dataHoraPartida += " " + menorHorarioPassageiro;
      }


      this.solicitacao.destinosIntermediarios.forEach(d => {

        let dataHoraPrevisaoChegada = d.dataPrevisaoChegada + " " + d.horaPrevisaoChegada;
        let dataHoraPrevisaoPartida = d.dataPrevisaoPartida + " " + d.horaPrevisaoPartida;

        if (!utils.dataMaiorOuIgual(dataHoraPartida, dataHoraPrevisaoChegada)) {
          estaOK = false;
        }
        if (!utils.dataMaiorOuIgual(dataHoraPartida, dataHoraPrevisaoPartida)) {
          estaOK = false;
        }
      });



      if (!estaOK) {
        this.errosDestinosData.push('Todos os campos "Data Previsão Chegada" ou "Data Previsão Partida" devem ser maiores ou iguais a data de partida.');
      }

      return this.errosDestinosData.length === 0;
    },

    // função para validar os campos do formulário destinos intermediários
    validarDestinoIntermediario(d) {

      this.errosDestinos = [];

      if (!d.endereco) {
        this.errosDestinos.push('Nenhum campo do "Endereço" foi preenchido.');
      } else {
        if (!d.endereco.cep) {
          this.errosDestinos.push('Campo "CEP" é obrigatório.');
        }
        if (!d.endereco.endereco) {
          this.errosDestinos.push('Campo "Endereço" é obrigatório.');
        }
        if (!d.endereco.numero) {
          this.errosDestinos.push('Campo "Número" é obrigatório.');
        }
        if (!d.endereco.bairro) {
          this.errosDestinos.push('Campo "Bairro" é obrigatório.');
        }
        if (!d.endereco.cidade) {
          this.errosDestinos.push('Campo "Cidade" é obrigatório.');
        }
        if (!d.endereco.estado) {
          this.errosDestinos.push('Campo "Estado" é obrigatório.');
        }
      }

      if (!d.dataPrevisaoChegada) {
        this.errosDestinos.push('Campo "Data Previsão Chegada" é obrigatório.');
      } else if (!utils.dataMaiorOuIgual(this.solicitacao.dataDaPartida, d.dataPrevisaoChegada)) {
        this.errosDestinos.push('Campo "Data Previsão Chegada" deve ser maior ou igual a data da partida.');
      }
      if (!d.horaPrevisaoChegada) {
        this.errosDestinos.push('Campo "Hora Previsão Chegada" é obrigatório.');
      }
      if (!d.dataPrevisaoPartida) {
        this.errosDestinos.push('Campo "Data Previsão Partida" é obrigatório.');
      } else if (!utils.dataMaiorOuIgual(this.solicitacao.dataDaPartida, d.dataPrevisaoPartida)) {
        this.errosDestinos.push('Campo "Data Previsão Partida" deve ser maior ou igual a data da partida.');
      }
      if (!d.horaPrevisaoPartida) {
        this.errosDestinos.push('Campo "Hora Previsão Partida" é obrigatório.');
      }

      let dataHoraPartida = this.solicitacao.dataDaPartida;

      // se for carga ou grupo, adicionar a hora da partida a data da partida
      if (this.tipoTransporteNormalizado === 'carga' || this.tipoTransporteNormalizado === 'grupo') {
        dataHoraPartida += " " + this.solicitacao.horarioDaPartida;
      } else if (this.tipoTransporteNormalizado === 'executivo') {
        let menorHorarioPassageiro = this.getMenorHorarioPassageiro();
        dataHoraPartida += " " + menorHorarioPassageiro;
      }

      let previsaoChegada = d.dataPrevisaoChegada + " " + d.horaPrevisaoChegada;
      let previsaoPartida = d.dataPrevisaoPartida + " " + d.horaPrevisaoPartida;

      // previsão partida dever ser maior ou igual previsão chegada
      if (!utils.dataMaiorOuIgual(previsaoChegada, previsaoPartida)) {
        this.errosDestinos.push('A previsão de partida deve ser maior ou igual a previsão de chegada');
      }

      // previsão chegada dever ser maior ou igual data (e hora) partida
      if (!utils.dataMaiorOuIgual(dataHoraPartida, previsaoChegada)) {
        this.errosDestinos.push('A previsão de chegada deve ser maior ou igual a data (e hora quando houver) de partida');
      }

      // previsão chegada dever ser maior ou igual data (e hora) partida
      if (!utils.dataMaiorOuIgual(dataHoraPartida, previsaoPartida)) {
        this.errosDestinos.push('A previsão de partida deve ser maior ou igual a data (e hora quando houver) de partida');
      }

      if (this.tipoTransporteNormalizado === 'grupo' && this.isObrigatorioLocalHospedagem()) {
        if (!d.localHospedagem) {
           this.errosDestinos.push('Campo "Local de Hospedagem" é obrigatório.');
        }
      }

      let destinosIntermediarios = this.solicitacao.destinosIntermediarios;
      if (destinosIntermediarios.length > 0) {

        // verifica se esta editando
        if (this.editandoDestIntermediarioIndex >= 0) {
          // data chegada deve ser maior que data partida dos destinos intermediarios anteriores
          for (let i = this.editandoDestIntermediarioIndex - 1; i >= 0; i--) {

            let destinoAnterior = destinosIntermediarios[i];

            let previsaoPartidaDestinoAnterior = destinoAnterior.dataPrevisaoPartida + " " + destinoAnterior.horaPrevisaoPartida;

            if (!utils.dataMaiorOuIgual(previsaoPartidaDestinoAnterior, previsaoChegada)) {
              this.errosDestinos.push('A previsão de chegada deve ser maior ou igual a previsão de partida dos destinos intermediários anteriores');

              break;
            }
          }

          for (let i = this.editandoDestIntermediarioIndex + 1; i < destinosIntermediarios.length - 1; i++) {

            let destinoPosterior = destinosIntermediarios[i];

            let previsaoPartidaDestinoPosterior = destinoPosterior.dataPrevisaoPartida + " " + destinoPosterior.horaPrevisaoPartida;

            if (!utils.dataMenor(previsaoChegada, previsaoPartidaDestinoPosterior)) {
              this.errosDestinos.push('A previsão de chegada deve ser menor que a previsão de partida dos destinos intermediários seguintes');

              break;
            }
          }
        } else {
          // então está inserindo

          // data chegada deve ser maior que data partida do ultimo destino intermediario
          let ultimoDestino = destinosIntermediarios[destinosIntermediarios.length - 1];

          let previsaoPartidaUltimoDestino = ultimoDestino.dataPrevisaoPartida + " " + ultimoDestino.horaPrevisaoPartida;

          if (!utils.dataMaior(previsaoPartidaUltimoDestino, previsaoChegada)) {
            this.errosDestinos.push('A previsão de chegada deve ser maior ou igual a previsão de partida do último destino intermediário');
          }


        }



      }

      return this.errosDestinos.length === 0;

    },

    // função de validação usada apenas para quanto a solicitação for para grupo
    // precisa ser informado exatamente 2 passageiros (responsáveis)
    validarQtdeResponsavelGrupo(){

      this.errosPassageiros = [];

      if (this.solicitacao.passageiros !== null && this.solicitacao.passageiros.length != 2) {
        this.errosPassageiros.push('É necessário que hajam 2 (dois) responsáveis pela viagem');
      }
      if (this.solicitacao.qtdePassageiros > this.solicitacao.capacidadePassageiros) {
        this.errosPassageiros.push('O número de passageiros informados é maior que a capacidade máxima permitida pelo veículo ('+this.solicitacao.capacidadePassageiros+' passageiros)');
      }

      return this.errosPassageiros.length === 0;

    },
    // função de validação usada apenas para quanto a solicitação for para executivo
    // precisa ser informado pelo menos 1 passageiro
    validarQtdePassageirosExecutivo(){

    if (this.solicitacao.passageiros !== null && this.solicitacao.passageiros.length < 1) {
      this.errosPassageiros.push('É necessário que haja pelo menos 1 (um) passageiro cadastrado');
    }

    return this.errosPassageiros.length === 0;

    },
    // função para validar os campos do Endereço de Origem da Carga
    validarOrigemQuandoCarga() {

      if (this.tipoTransporteNormalizado === 'carga' && this.solicitacao.necessidadePassageiroAcompanhante === 'Não') {

        this.errosOrigemQuandoCarga = [];

        if (!this.solicitacao.localApresentacaoCarga) {
          this.errosOrigemQuandoCarga.push('Campo "Local de Apresentação" é obrigatório.');
        }

        if (!this.solicitacao.enderecoOrigemCarga) {
          this.errosOrigemQuandoCarga.push('Nenhum campo do "Endereço" foi preenchido.');
        } else {
          if (!this.solicitacao.enderecoOrigemCarga.cep) {
            this.errosOrigemQuandoCarga.push('Campo "CEP" é obrigatório.');
          }
          if (!this.solicitacao.enderecoOrigemCarga.endereco) {
            this.errosOrigemQuandoCarga.push('Campo "Endereço" é obrigatório.');
          }
          if (!this.solicitacao.enderecoOrigemCarga.numero) {
            this.errosOrigemQuandoCarga.push('Campo "Número" é obrigatório.');
          }
          if (!this.solicitacao.enderecoOrigemCarga.bairro) {
            this.errosOrigemQuandoCarga.push('Campo "Bairro" é obrigatório.');
          }
          if (!this.solicitacao.enderecoOrigemCarga.cidade) {
            this.errosOrigemQuandoCarga.push('Campo "Cidade" é obrigatório.');
          }
          if (!this.solicitacao.enderecoOrigemCarga.estado) {
            this.errosOrigemQuandoCarga.push('Campo "Estado" é obrigatório.');
          }
        }

        return this.errosOrigemQuandoCarga.length === 0;
      } else {
        return true;
      }
    },


    // função para validar os campos do bloco destino final
    validarDestinoFinal() {

      this.errosDestinoFinal = [];

      let dataHoraPartida = this.solicitacao.dataDaPartida;
      let dataHoraRetorno = this.solicitacao.destinoFinal.dataRetorno + " " + this.solicitacao.destinoFinal.horarioRetorno;

      if (!this.solicitacao.destinoFinal.dataRetorno) {
        this.errosDestinoFinal.push('Campo "Data Retorno" é obrigatório.');
      } else if (!utils.dataMaiorOuIgual(dataHoraPartida, dataHoraRetorno)) {
        this.errosDestinoFinal.push('Campo "Data Retorno" deve ser maior ou igual a data da partida.');
      }
      if (!this.solicitacao.destinoFinal.horarioRetorno) {
        this.errosDestinoFinal.push('Campo "Horário Retorno" é obrigatório.');
      }


      // se for carga, adicionar a hora da partida a data da partida
      // verificar se a data de retorno é maior ou igual a data de partida (considerar hora)
      if (this.tipoTransporteNormalizado === 'carga') {
        dataHoraPartida += " " + this.solicitacao.horarioDaPartida;

        if (!utils.dataMaiorOuIgual(dataHoraPartida, dataHoraRetorno)) {
          this.errosDestinoFinal.push('Campo "Data Retorno" deve ser maior ou igual a data da partida.');
        }
      }

      // se for executivo pegar a maior hora da lista de passageiro (considera que será o ultimo a embarcar)
      // e verificar se a data de retorno é maior ou igual ao momento do último passageiro embarcado.
      if (this.tipoTransporteNormalizado === 'executivo') {
        if (this.solicitacao.passageiros) {
          let maiorHorarioPassageiro = this.getMaiorHorarioPassageiro();
          let maiorDataHoraPassageiro = this.solicitacao.dataDaPartida + " " + maiorHorarioPassageiro

          if (!utils.dataMaiorOuIgual(maiorDataHoraPassageiro, dataHoraRetorno)) {
            this.errosDestinoFinal.push('Campo "Data Retorno" deve ser maior ou igual a data da partida do último passageiro a embarcar.');
          }
        }
      }

      // verificar se data de retorno é maior ou igual ao ultimo destino intermediário cadastrado
      if (this.solicitacao.destinosIntermediarios) {
        let maiorDataHorarioDestinoIntermediario = this.getMaiorDataHorarioDestIntermediario();

        if (maiorDataHorarioDestinoIntermediario !== null && !utils.dataMaiorOuIgual(maiorDataHorarioDestinoIntermediario, dataHoraRetorno)) {
          this.errosDestinoFinal.push('Campo "Data Retorno" deve ser maior ou igual a data da partida do último destino intermediário.');
        }
      }


      if (!this.solicitacao.destinoFinal.localDestinoFinal) {
        this.errosDestinoFinal.push('Campo "Nome Local/Destino" é obrigatório.');
      }

      if (this.tipoTransporteNormalizado !== 'grupo' && this.solicitacao.necessidadePassageiroAcompanhante !== 'Não') {
        if (!this.solicitacao.destinoFinal.motoristaAguardar) {
          this.errosDestinoFinal.push('Campo "Motorista aguardar retorno" é obrigatório.');
        }
      }

      if (this.tipoTransporteNormalizado === 'grupo' && this.isObrigatorioLocalHospedagem()) {
        if (!this.solicitacao.destinoFinal.localHospedagem) {
          this.errosDestinoFinal.push('Campo "Local de Hospedagem" é obrigatório.');
        }
      }

      if (!this.solicitacao.destinoFinal.enderecoDestinoFinal) {
        this.errosDestinoFinal.push('Nenhum campo referente ao endereço foi digitado.');
      } else {
        if (!this.solicitacao.destinoFinal.enderecoDestinoFinal.cep) {
          this.errosDestinoFinal.push('Campo "CEP" é obrigatório.');
        }
        if (!this.solicitacao.destinoFinal.enderecoDestinoFinal.endereco) {
          this.errosDestinoFinal.push('Campo "Endereço" é obrigatório.');
        }
        if (!this.solicitacao.destinoFinal.enderecoDestinoFinal.numero) {
          this.errosDestinoFinal.push('Campo "Num." é obrigatório.');
        }
        if (!this.solicitacao.destinoFinal.enderecoDestinoFinal.bairro) {
          this.errosDestinoFinal.push('Campo "Bairro" é obrigatório.');
        }
        if (!this.solicitacao.destinoFinal.enderecoDestinoFinal.cidade) {
          this.errosDestinoFinal.push('Campo "Cidade" é obrigatório.');
        }
        if (!this.solicitacao.destinoFinal.enderecoDestinoFinal.estado) {
          this.errosDestinoFinal.push('Campo "Estado" é obrigatório.');
        }
      }

      return this.errosDestinoFinal.length === 0;

    },


    // função para validar os dados do bloco dados gerais
    validarDadosGerais() {
      this.errosDadosGerais = [];

      if (!this.solicitacao.tipoTransporte) {
        this.errosDadosGerais.push('Campo "Tipo de Transporte" é obrigatório.');
      }

      if (this.tipoTransporteNormalizado === 'grupo') {
        if (!this.solicitacao.tipoViagem) {
          this.errosDadosGerais.push('Campo "Tipo de Viagem" é obrigatório.');
        }
        if (!this.solicitacao.tipoVeiculo) {
          this.errosDadosGerais.push('Campo "Tipo de Veículo" é obrigatório.');
        }
        if (!this.solicitacao.qtdePassageiros || this.solicitacao.qtdePassageiros <= 2) {
          this.errosDadosGerais.push('Campo "Quantidade de passageiros" é obrigatório e deve ser maior que 2.');
        }
      }

      if (!this.solicitacao.dataDaPartida) {
        this.errosDadosGerais.push('Campo "Data da Partida" é obrigatório.');
      } else if (utils.isDataPassada(this.solicitacao.dataDaPartida)) {
        this.errosDadosGerais.push('Data de partida inválida (passado).');
      } else if (this.tipoTransporteNormalizado !== 'grupo' && !utils.validarDataViagem(this.solicitacao.dataDaPartida, this.feriados, 3)) {
        this.errosDadosGerais.push('Você pode inserir o agendamento com 03 dias úteis de antecedência à viagem.');
      } else if (this.tipoTransporteNormalizado === 'grupo' && !utils.validarDataViagem(this.solicitacao.dataDaPartida, this.feriados, 15)) {
        this.errosDadosGerais.push('Você pode inserir o agendamento com 15 dias úteis de antecedência à viagem.');
      }

      if (this.tipoTransporteNormalizado === 'carga') {
        if (!this.solicitacao.horarioDaPartida) {
          this.errosDadosGerais.push('Campo "Horário Partida" é obrigatório.');
        }
        if (!this.solicitacao.especificacaoDaCarga) {
          this.errosDadosGerais.push('Campo "Especificação da carga transportada" é obrigatório.');
        }
        if (!this.solicitacao.necessidadePassageiroAcompanhante) {
          this.errosDadosGerais.push('Campo "Necessidade passageiro acompanhante" é obrigatório.');
        }
      }

      if (!this.solicitacao.aeroporto.selecionado) {
        this.errosDadosGerais.push('Campo "É aeroporto?" é obrigatório.');
      } else if (this.solicitacao.aeroporto.selecionado !== 'Não') {
        if (!this.solicitacao.aeroporto.detalhes) {
          this.errosDadosGerais.push('Você precisa informar os dados do aeroporto, voo e cia aérea.');
        } else {
          if (!this.solicitacao.aeroporto.detalhes.nomeAeroporto) {
            this.errosDadosGerais.push('Campo "Nome do Aeroporto" é obrigatório.');
          }
          if (!this.solicitacao.aeroporto.detalhes.dataVoo) {
            this.errosDadosGerais.push('Campo "Data do Voo" é obrigatório.');
          }
          if (!this.solicitacao.aeroporto.detalhes.numeroVoo) {
            this.errosDadosGerais.push('Campo "Número do Voo" é obrigatório.');
          }
          if (!this.solicitacao.aeroporto.detalhes.horarioChegadaPartidaVoo) {
            this.errosDadosGerais.push('Campo "Horário Chegada/Partida do Voo" é obrigatório.');
          }
          if (!this.solicitacao.aeroporto.detalhes.origemDestinoVoo) {
            this.errosDadosGerais.push('Campo "Origem/Destino Voo" é obrigatório.');
          }
          if (!this.solicitacao.aeroporto.detalhes.ciaAerea) {
            this.errosDadosGerais.push('Campo "Cia Aérea" é obrigatório.');
          }
        }
      }




      return this.errosDadosGerais.length === 0;
    },

    validarInfoAdicionais() {
      this.errosInformacoesAdicionais = [];

      if (!this.solicitacao.infoAdicionais.finalidade) {
        this.errosInformacoesAdicionais.push('Campo "Finalidade" é obrigatório.');
      } else {
        if (!this.solicitacao.infoAdicionais.finalidade.tipo) {
          this.errosInformacoesAdicionais.push('Campo "Finalidade" é obrigatório.');
        }
        if (!this.solicitacao.infoAdicionais.finalidade.detalhes) {
          this.errosInformacoesAdicionais.push('Campo "Especificar" é obrigatório.');
        }
      }


      return this.errosInformacoesAdicionais.length === 0;
    },

    // função para validar os dados do bloco dados do responsavel
    validarDadosResponsavel() {
      this.errosDadosResponsavel = [];

      if (!this.solicitacao.centroOrcamentario) {
        this.errosDadosResponsavel.push('Campo "Centro Orçamentário" é obrigatório.');
      }
      if (this.temContasLocais && !this.solicitacao.contaLocal) {
        this.errosDadosResponsavel.push('Campo "Conta Local" é obrigatório.');
      }
      if (!this.solicitacao.responsavelPelaSolicitacao) {
        this.errosDadosResponsavel.push('Campo "Responsável pela solicitação" é obrigatório.');
      } 
      if (!this.solicitacao.unidade || !this.solicitacao.unidade.sigla) {
        this.errosDadosResponsavel.push('Campo "Unidade" é obrigatório.');
      }
      if (!this.solicitacao.ramal) {
        this.errosDadosResponsavel.push('Campo "Ramal" é obrigatório.');
      }
      if (!this.solicitacao.telefoneForaExpediente) {
        this.errosDadosResponsavel.push('Campo "Telefone Fora Expediente" é obrigatório.');
      }      

      return this.errosDadosResponsavel.length === 0;
    },

    validarDestinoIntermediarioQuestao() {
      this.errosDestinoIntermediarioQuestao = [];

      if (this.solicitacao.temDestinoIntermediario === 'Sim' && this.solicitacao.destinosIntermediarios.length == 0) {
        this.errosDestinoIntermediarioQuestao.push('Se existe destino intermediário é necessário cadastrá-lo. Caso não tenha destino intermediário, escolha "Não" para o campo "Tem destino intermediário?".');
      }

      return this.errosDestinoIntermediarioQuestao.length === 0;
    },

    validarEmail(email) {
      // Expressão regular para validar o formato básico de um e-mail
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },

    salvarDestIntermediario(destIntermediario) {
      const novoDestinoIntermediario = {
        ...destIntermediario
      };

      if (this.validarDestinoIntermediario(novoDestinoIntermediario)) {

        if (this.isEditandoDestIntermediario && this.editandoDestIntermediarioIndex !== -1) {
          // Atualizar 
          this.solicitacao.destinosIntermediarios.splice(this.editandoDestIntermediarioIndex, 1, novoDestinoIntermediario);
          this.isEditandoDestIntermediario = false;
          this.editandoDestIntermediarioIndex = -1;
        } else {
          // Adicionar 
          this.solicitacao.destinosIntermediarios.push(novoDestinoIntermediario);
        }

        this.destIntermediarioEditando = {};
      }

    },

    receberEmitAeroporto(aeroporto) {

      // Criando um novo objeto aeroporto usando spread operator
      const novoAeroporto = {
        ...aeroporto
      };

      // Adicionando o novo aeroporto ao array aeroporto
      this.solicitacao.aeroporto = novoAeroporto;

    },

    receberEmitEnderecoAeroporto(enderecoAeroporto) {

      const novoEnderecoAeroporto = {
        ...enderecoAeroporto
      };

      this.enderecoAeroporto = novoEnderecoAeroporto;

    },

    excluirPassageiro(index) {
      this.solicitacao.passageiros.splice(index, 1);
    },

    excluirDestIntermediario(index) {
      this.solicitacao.destinosIntermediarios.splice(index, 1);
    },

    async confirmarExcluirPassageiro(index) {
      console.log("confirmar excluir");

      const result = await this.$swal
        .fire({
          title: "Você está prestes a excluir...",
          text: "Tem certeza que deseja excluir este endereco?",
          icon: "question",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Sim",
          denyButtonText: "Não"
        });
      if (result.isConfirmed) {
        this.excluirPassageiro(index);
      }
    },

    async confirmarExcluirDestinoIntermediario(index) {
      console.log("confirmar excluir");

      const result = await this.$swal
        .fire({
          title: "Você está prestes a excluir...",
          text: "Tem certeza que deseja excluir este destino intermediário?",
          icon: "question",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Sim",
          denyButtonText: "Não",
        });

      if (result.isConfirmed) {
        this.excluirDestIntermediario(index);
      }
    },

    editarPassageiro(index) {
      this.passageiroEditando = { ...this.solicitacao.passageiros[index] };
      this.isEditandoPassageiro = true;
      this.editandoPassageiroIndex = index;
    },

    editarDestinoIntermediario(index) {
      this.destIntermediarioEditando = { ...this.solicitacao.destinosIntermediarios[index] };
      this.isEditandoDestIntermediario = true;
      this.editandoDestIntermediarioIndex = index;
    },

    updateContasLocaisStatus(temContas) {
      this.temContasLocais = temContas;
    },

    // necessário declarar explicitaente para usar em um loop v-for
    formatarDataBR,

    // método para buscar os feriados
    async getFeriados() {
      try {
        const path = '/feriado';
        const response = await this.$axios.get(path);

        return response.data;

      } catch (error) {

        if (error.response) {
          console.error('(buscando feriados) Resposta do servidor com status:', error.response.status);
        } else {
          console.error('(buscando feriados) Erro sem resposta do servidor:', error.message);
        }

        return null;
      }
    },

    // função para retornar o maior horário no array de passageiros
    getMaiorHorarioPassageiro() {
      if (this.solicitacao.passageiros.length === 0) {
        return "00:00";
      }

      let maiorHorario = this.solicitacao.passageiros[0].horarioDaPartida;

      this.solicitacao.passageiros.forEach(p => {
        if (p.horarioDaPartida > maiorHorario) {
          maiorHorario = p.horarioDaPartida;
        }
      });

      return maiorHorario;
    },

    // função para retornar o maior horário no array de destinos intermediarios
    getMaiorDataHorarioDestIntermediario() {
      if (this.solicitacao.destinosIntermediarios.length === 0) {
        return null;
      }

      let maiorDataHorario = this.solicitacao.destinosIntermediarios[0].dataPrevisaoPartida + " " + this.solicitacao.destinosIntermediarios[0].horaPrevisaoPartida;

      this.solicitacao.destinosIntermediarios.forEach(d => {
        let maiorDataHorarioTemp = d.dataPrevisaoPartida + " " + d.horaPrevisaoPartida;

        if (maiorDataHorarioTemp > maiorDataHorario) {
          maiorDataHorario = maiorDataHorarioTemp;
        }
      });

      return maiorDataHorario;
    },

    // função para retornar o menor horário no array de passageiros
    getMenorHorarioPassageiro() {
      if (this.solicitacao.passageiros.length === 0) {
        return "00:00";
      }

      let menorHorario = this.solicitacao.passageiros[0].horarioDaPartida;

      this.solicitacao.passageiros.forEach(p => {
        if (p.horarioDaPartida < menorHorario) {
          menorHorario = p.horarioDaPartida;
        }
      });

      return menorHorario;
    },

    getTotalDiasUteisParaSolicitacao() {
      let totalDiasUteis = 0;

      if (this.tipoTransporteNormalizado !== 'grupo') {
        totalDiasUteis = 3;
      } else {
        totalDiasUteis = 15;
      }

      return totalDiasUteis;
    },

    isObrigatorioLocalHospedagem(){
      if (this.solicitacao.tipoViagem != null){
        return this.solicitacao.tipoViagem.toUpperCase().includes("ESTADUAL");
      }
      return false;
    }
  },


  components: {
    CentroOrcamentarioSelect,
    ContaLocalSelect,
    UnidadeSelect,
    TipoViagemSelect,
    TipoVeiculoSelect,
    Passageiro,
    DestinoIntermediario,
    DadosAeroporto,
    Endereco,
    Finalidade
  },

  data() {
    return {
      solicitacao: {
        centroOrcamentario: null,
        contaLocal: null,
        responsavelPelaSolicitacao: this.$keycloak.tokenParsed.given_name,
        unidade: { sigla: null, descricao: null, centroOrcamentario: null, contaLocal: null },
        ramal: null,
        telefoneForaExpediente: null,
        tipoTransporte: null,
        tipoViagem: null,
        tipoVeiculo: null,
        capacidadePassageiros: null,
        especificacaoDaCarga: null,
        necessidadePassageiroAcompanhante: null,
        enderecoOrigemCarga: null,
        localApresentacaoCarga: null,
        dataDaPartida: null,
        horarioDaPartida: null,
        aeroporto: {
          selecionado: null,  // valor inicial
        },
        qtdePassageiros: null,
        temDestinoIntermediario: 'Não',
        passageiros: [],
        destinosIntermediarios: [],
        destinoFinal: {
          dataRetorno: null,
          horarioRetorno: null,
          localDestinoFinal: null,
          enderecoDestinoFinal: null,
          motoristaAguardar: null,
          localHospedagem: null,
        },
        infoAdicionais: {
          telefone: null,
          ramal: null,
          finalidade: {
            tipo: null,
            detalhes: null,
          },
          observacoes: null
        }
      },

      feriados: [],

      dataMinima: "",
      temContasLocais: true,

      passageiroEditando: {},
      isEditandoPassageiro: false,
      editandoPassageiroIndex: -1,

      destIntermediarioEditando: {},
      isEditandoDestIntermediario: false,
      editandoDestIntermediarioIndex: -1,

      enderecoAeroporto: {},

      // para guardar mensagens de validação quando um campo não estiver ok
      errosDestinos: [],
      errosDestinosData: [],
      errosDestinoFinal: [],
      errosPassageiros: [],
      errosInformacoesAdicionais: [],
      errosDadosGerais: [],
      errosDadosResponsavel: [],
      errosDestinoIntermediarioQuestao: [],
      errosOrigemQuandoCarga: [],

      listaPassageirosUrl: 'https://www.prefeitura.unicamp.br/arquivo/uploads/lista-de-passageiros/'
    };
  },

  created() {
    this.solicitacao.tipoTransporte = this.$route.params.tipo || 'Indefinido';
  },

  watch: {

    '$route.params.tipo'(newValue) {
      this.solicitacao.tipoTransporte = newValue;
    },

    'solicitacao.dataDaPartida'() {
      this.dataMinima = this.solicitacao.dataDaPartida;
    },

    enderecoAeroporto(newValue) {

      // necessário para manter os dados do endereco do aeroporto para destino final
      // quando o aeroporto for o destino
      if (this.solicitacao.aeroporto.selecionado === 'Destino') {
        this.solicitacao.destinoFinal.enderecoDestinoFinal = newValue;
      }
    }
  },

  computed: {
    tipoTransporteNormalizado() {
      if (this.solicitacao.tipoTransporte) {
        return this.solicitacao.tipoTransporte.toLowerCase();
      }
      return "";
    }
  },

  async mounted() {
    // descomentar a linha abaixo para buscar os feriados
    this.feriados = await this.getFeriados();

    let dataAtual = new Date();
    dataAtual.setHours(0, 0, 0, 0);

    let totalDiasUteis = this.getTotalDiasUteisParaSolicitacao();


    this.dataMinima = utils.formatarDataISO(utils.getPrimeiraDataViagemPermitida(this.feriados, totalDiasUteis));

    this.solicitacao.tipoTransporte = this.$route.params.tipo || 'Indefinido';

    if(this.tipoTransporteNormalizado === 'executivo') {
      this.$swal.fire({
              title: 'Atenção',
              html: 'A utilização de Carro Executivo foi dimensionada para atendimentos de até 2h30min e 75km. <br /><br />' +
                    'Caso seu agendamento ultrapasse esses parâmetros, pedimos a gentileza de utilizar a opção de Táxi  <br /> <br />'+
                    '<a href="https://originaltaxi.com.br/portal/login/gneexecutivo" target="_blank">https://originaltaxi.com.br/portal/login/gneexecutivo</a>',
              icon: 'warning',
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: true,
              focusConfirm: true
            })
    }

  }



};
</script>

<style src="../css/transporte.css"></style>